import axios from "axios";
import { isNative, nativeHeaders, getTokens, setTokens, openExternal, WEBSITE_URL } from "@/lib/native";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

if (isNative) {
  api.interceptors.request.use((config) => {
    config.headers = { ...config.headers, ...nativeHeaders() };
    return config;
  });
  api.interceptors.response.use(
    (res) => {
      if (res.data?.tokens) { setTokens(res.data.tokens); delete res.data.tokens; }
      return res;
    },
    async (err) => {
      const original = err.config;
      const refresh = getTokens()?.refresh_token;
      if (err.response?.status === 401 && refresh && !original._retried && !original.url.includes("/auth/")) {
        original._retried = true;
        try {
          await api.post("/auth/refresh", { refresh_token: refresh });
          return api(original);
        } catch { setTokens(null); }
      }
      return Promise.reject(err);
    },
  );
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function readSse(body, onEvent) {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buf.indexOf("\n\n")) !== -1) {
      const block = buf.slice(0, idx);
      buf = buf.slice(idx + 2);
      let event = "message", data = "";
      for (const line of block.split("\n")) {
        if (line.startsWith("event:")) event = line.slice(6).trim();
        else if (line.startsWith("data:")) data += line.slice(5).trim();
      }
      if (data) onEvent(event, JSON.parse(data));
    }
  }
}

export async function startCheckout(lookup_key) {
  const { data } = await api.post("/payments/checkout", {
    lookup_key,
    origin_url: isNative ? WEBSITE_URL : window.location.origin,
  });
  if (data.checkout_url) await openExternal(data.checkout_url);
}
